// extracted by mini-css-extract-plugin
export var heroBanner = "HeroBannerSlideshow-module--hero-banner--5f1da";
export var newsMessage = "HeroBannerSlideshow-module--news-message--6af28";
export var newsMessageContainer = "HeroBannerSlideshow-module--news-message-container--fba0b";
export var swiperSlider = "HeroBannerSlideshow-module--swiper-slider--720f6";